export default "__VITE_ASSET__BvFDCNwY__"